module.exports = __webpack_public_path__ + "img/jsfni1.4ac1102a.png";